<template>
  <div ref="container">
    <div style="position: relative">
      <img
        :src="product.titlePicture"
        :width="imgwidth + 'px'"
        :height="imgHeight + 'px'"
        class="img_index"
      />
      <div class="h_title0">
        <h1 class="h_title">{{ product.title }}</h1>
      </div>
    </div>

    <div class="margin_top">
      <el-row style="background-color: #efecec">
        <el-col :span="4" style="text-align: left">
          <div style="width: 1px; height: 1px"></div>
          <el-menu
            id="menuDiv"
            ref="menuDiv"
            :default-active="menuId"
            :default-openeds="['4', '5']"
            @select="handleSelect"
            @close="handleClose"
            background-color="#efecec"
            text-color="#505050"
            active-text-color="#505050"
            :class="searchBarFixed ? 'isFixed' : ''"
            :style="{ bottom: bottomHeight > 0 ? bottomHeight + 'px' : 0 }"
            style="border: none; max-width: 200px"
          >
            <div class="div_menu_title">产品中心</div>
            <div v-for="menu in productList" :key="menu.id">
              <el-menu-item
                v-if="
                  menu.productDetailList == null ||
                  menu.productDetailList.length === 0 ||
                  menu.id === '6'
                "
                :index="menu.id"
              >
                <span
                  slot="title"
                  :style="{ fontWeight: menu.id === '6' ? 'bold' : 'normal' }"
                  >{{ menu.title }}</span
                >
              </el-menu-item>
              <el-submenu v-else :index="menu.id">
                <span slot="title" style="font-weight: bold">{{
                  menu.title
                }}</span>
                <el-menu-item
                  v-for="submenu in menu.productDetailList"
                  :key="submenu.id"
                  :index="submenu.id"
                  >{{ submenu.title }}</el-menu-item
                >
              </el-submenu>
            </div>
          </el-menu>
        </el-col>
        <el-col :span="20" style="background-color: #ffffff">
          <div style="width: 1px; height: 1px"></div>
          <div
            v-for="item in productList"
            :key="item.id"
            style="margin: 30px 0 0 40px"
            :style="item.id === '1' ? 'margin-top: 0;' : ''"
          >
            <h3
              :style="{ 'margin-top': item.id === '1' ? '0' : '' }"
              :id="item.id"
              style="text-align: left"
            >
              {{ item.title }}
            </h3>

            <div
              v-for="(content, index) in item.content"
              :key="index"
              style="text-align: left; margin-bottom: 20px"
            >
              <span>{{ content }}</span>
            </div>
            <el-image
              v-if="item.picture != null"
              :src="item.picture"
              class="img_product"
            />

            <div v-if="item.id !== '5' && item.id !== '6'">
              <div
                v-for="productDetail in item.productDetailList"
                :key="productDetail.id"
                style="text-align: left; margin-bottom: 20px"
              >
                <h4 :id="productDetail.id">{{ productDetail.title }}</h4>
                <div v-if="productDetail.id !== '4-3'">
                  <div
                    v-for="(detail, index) in productDetail.detailList"
                    :key="index"
                    class="dic_detail_list"
                  >
                    <el-row :gutter="20">
                      <el-col :span="11" style="text-align: center">
                        <el-image :src="detail.picture" style="height: 300px" />
                      </el-col>
                      <el-col
                        :span="11"
                        :offset="2"
                        :class="
                          productDetail.id === '4-2' ? 'div_detail_center' : ''
                        "
                      >
                        <div style="padding-bottom: 10px">
                          <h5
                            v-if="detail.title != null && detail.title !== ''"
                          >
                            {{ detail.title }}
                          </h5>
                          <div
                            v-for="(content, i) in detail.content"
                            :key="i"
                            style="line-height: 26px"
                          >
                            <span
                              :style="{
                                'font-weight':
                                  productDetail.id === '4-2' ? 'bold' : '',
                              }"
                              >{{ content.label + "：" + content.value }}</span
                            >
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-else-if="productDetail.id === '4-3'">
                  <!-- <el-row>
                    <el-col :span="12" v-for="(detail, index) in productDetail.detailList" :key="index" v-if="index < 2"
                      style="text-align: center;">
                      <div class="dic_detail_list" style="margin-top: 0;"
                        :style="index === 0 ? 'margin-right: 10px;' : 'margin-left: 10px;'">
                        <el-row :gutter="20">
                          <el-col :span="11" style="text-align: center;">
                            <el-image :src="detail.picture" style="height: 270px; margin: 15px 0;" />
                          </el-col>
                          <el-col :span="13">
                            <div style="padding-bottom: 10px;">
                              <h5>{{ detail.title }}</h5>
                              <div v-for="(content, index) in detail.content" :key="index" style="line-height: 26px;">
                                <span>{{ content.label + '：' + content.value }}</span>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row> -->
                  <div class="dic_detail_list">
                    <el-row :gutter="20">
                      <el-col :span="11" style="text-align: center">
                        <el-image
                          :src="productDetail.detailList[2].picture"
                          style="height: 300px"
                        />
                      </el-col>
                      <el-col :span="11" :offset="2">
                        <div style="padding-bottom: 10px">
                          <h5>{{ productDetail.detailList[2].title }}</h5>
                          <div
                            v-for="(content, index) in productDetail
                              .detailList[2].content"
                            :key="index"
                            style="line-height: 26px"
                          >
                            <span>{{
                              content.label + "：" + content.value
                            }}</span>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="item.id === '5'">
              <div
                v-for="(productDetail, index) in item.productDetailList"
                :key="productDetail.id"
                :id="productDetail.id"
                class="dic_detail_list"
              >
                <el-row :gutter="20">
                  <el-col
                    v-if="index % 2 === 0"
                    :span="13"
                    style="text-align: center"
                  >
                    <el-image
                      :src="productDetail.picture"
                      style="height: 300px"
                    />
                  </el-col>
                  <el-col
                    :span="10"
                    :offset="index % 2 === 0 ? 1 : 0"
                    class="div_detail_center"
                  >
                    <div style="padding-bottom: 10px">
                      <h4 style="margin-top: 0">{{ productDetail.title }}</h4>
                      <div
                        v-for="(content, i) in productDetail.content"
                        :key="i"
                        style="line-height: 26px; display: flex"
                      >
                        <i
                          class="el-icon-star-on"
                          style="line-height: 26px; margin-right: 5px"
                        />
                        <div>{{ content }}</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col
                    v-if="index % 2 === 1"
                    :span="13"
                    :offset="1"
                    style="text-align: center"
                  >
                    <el-image
                      :src="productDetail.picture"
                      style="height: 300px"
                    />
                  </el-col>
                </el-row>
              </div>
            </div>

            <div v-else-if="item.id === '6'">
              <div
                v-for="(productDetail, index) in item.productDetailList"
                :key="productDetail.id"
                :id="productDetail.id"
                class="dic_detail_list"
              >
                <el-row :gutter="20">
                  <el-col
                    v-if="index % 2 === 0"
                    :span="productDetail.id === '6-3' ? 5 : 13"
                    style="text-align: center"
                  >
                    <el-image
                      :src="productDetail.picture"
                      style="height: 300px"
                    />
                  </el-col>
                  <el-col
                    :span="productDetail.id === '6-3' ? 17 : 10"
                    :offset="index % 2 === 0 ? 1 : 0"
                    class="div_detail_center"
                  >
                    <div style="padding-bottom: 10px">
                      <h4 style="margin-top: 0">{{ productDetail.title }}</h4>
                      <div
                        v-for="(content, i) in productDetail.content"
                        :key="i"
                        style="line-height: 26px; display: flex"
                      >
                        <i
                          class="el-icon-star-on"
                          style="line-height: 26px; margin-right: 5px"
                        />
                        <div>{{ content }}</div>
                      </div>
                    </div>
                  </el-col>
                  <el-col
                    v-if="index % 2 === 1"
                    :span="13"
                    :offset="1"
                    style="text-align: center"
                  >
                    <el-image
                      :src="productDetail.picture"
                      style="height: 300px"
                    />
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      product: global.product,
      productList: global.product.productList,
      menuId: "1",
      searchBarFixed: false,
      bottomHeight: 0,
      imgHeight: 525,
      imgwidth: 0,
      pageWidth: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      window.addEventListener("scroll", vm.handleScroll, false);
    });
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleScroll);
    next();
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgwidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgwidth = window.innerWidth;
  },
  methods: {
    handleSelect(index) {
      const scrollTop = document.getElementById(index);
      scrollTop.scrollIntoView();
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const offsetTop = document.querySelector("#menuDiv").offsetTop;
      this.searchBarFixed = scrollTop > offsetTop + 640;

      // 能看到的页面的高度
      let windowHeight = window.innerHeight;
      // 监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let scrollHeight = this.$refs.container.scrollHeight;
      this.bottomHeight = scrollTop + windowHeight - scrollHeight - 110;
    },
    handleClose(key, keyPath) {
      this.$refs.menuDiv.open(keyPath);
    },
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgwidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.h_title0 {
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  /* 让文字居中 */
}

.h_title {
  font-size: 3em;
  color: #000000;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  width: 480px;
}

.div_menu_title {
  background-color: #999999;
  padding: 0 20px;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

.el-icon-arrow-down:before {
  content: none;
}

.isFixed {
  position: fixed;
  top: 0;
  z-index: 999;
  overflow-y: auto;
}

.img_product {
  width: 960px;
  //height: 720px;
}

.dic_detail_list {
  text-align: left;
  margin-top: 20px;
  background-color: #e5e5e5;
  padding: 20px 30px;
}

.div_detail_center {
  height: 304px;
  display: flex;
  align-items: center;
}

.img_index {
  position: relative;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product.vue